<template>
  <div class="page">
    <div class="toux">
      <img
        :src="userinfo.avatar ? userinfo.avatar : 'https://gcaibang-bucket.oss-cn-chengdu.aliyuncs.com/assets/img/avatar.png'"
        alt="" srcset="">
      <div class="btn" @click="setAvatar">修改头像</div>
      <input type="file" ref="file" style="display: none;" v-on:change="handleDrop($event)">
    </div>
    <div class="infoBlock">
      <div class="ite">
        <div class="text_l">账号：</div>
        <div>{{ userinfo.username }}</div>
      </div>
      <div class="ite">
        <div class="text_l">昵称：</div>
        <div>
          <!-- <InputConfim v-model="userinfos.nickname" ></InputConfim> -->
          <div class="inputflex">
            <div v-if="flag">{{ userinfo.nickname }}</div>
            <div v-else>
              <input ref="inputs" type="text" v-model="userinfo.nickname">
            </div>
            <div class="btn" v-if="flag" @click="chang">修改</div>
            <div class="btn" v-else @click="confirm">确定</div>
          </div>
        </div>
      </div>
      <div class="ite">
        <div class="text_l">密码：</div>
        <div class="text_r_flex">
          <div> ********</div>
          <div class="btn" @click="open">修改</div>
        </div>
      </div>
      <div class="ite">
        <div class="text_l">授权：</div>
        <div class="text_r_flex">
          <img src="@/assets/user/wx.png" alt="">
          <div style="display: flex;" v-if="userinfo.openid == '' || userinfo.openid == null">
            <div>请绑定微信</div>
            <div class="btn" @click="showPop = true">授权</div>
          </div>
          <div style="display: flex;" v-else>
            <div>{{ userinfo.nickname }}</div>
            <div class="btn" @click="jcshouquan">解除授权</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 微信授权弹窗 -->
    <el-dialog class="dialogs" title="请使用微信扫码授权" :visible.sync="showPop" width="430px">
      <div class="zfpop">
        <div class="dimg">
          <img :src="userinfo.code_image" alt="" srcset="">
        </div>
      </div>
    </el-dialog>
    <!-- 修改密码弹窗 -->
    <el-dialog class="dialogs" title="修改密码" :visible.sync="showPassword" width="522px">
      <div class="zfpop">
        <el-form ref="form" :model="user" :rules="rules" label-width="80px">
          <el-form-item label="账号">
            <div>{{ userinfo.username }}</div>
          </el-form-item>
          <el-form-item label="原密码" prop="oldPassword">
            <el-input v-model="user.oldPassword" placeholder="请输入原密码" type="password" show-password />
          </el-form-item>
          <el-form-item label="新密码" prop="newPassword">
            <el-input v-model="user.newPassword" placeholder="请输入新密码" type="password" show-password />
          </el-form-item>
          <el-form-item label="确认密码" prop="newPassword2">
            <el-input v-model="user.newPassword2" placeholder="请确认新密码" type="password" show-password />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <span class="k_btn" @click="showPassword = false" style="margin-right: 20px;">取 消</span>
        <span class="z_btn" @click="submit">确 定</span>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUserInfo, removeWxAuth, saveUserInfo, changePassword } from '@/api/user.js'
import InputConfim from '@/components/inputConfim'
import { uploadOssPut } from '@/utils/uploadOss.js';

export default {
  components: {
    InputConfim
  },
  name: '',
  data() {
    const equalToPassword = (rule, value, callback) => {
      if (this.user.newPassword !== value) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    };
    return {
      showPassword: false,
      showPop: false,
      user: {
        oldPassword: undefined,
        newPassword: undefined,
        newPassword2: undefined
      },

      // 表单校验
      rules: {
        oldPassword: [
          { required: true, message: "旧密码不能为空", trigger: "blur" }
        ],
        newPassword: [
          { required: true, message: "新密码不能为空", trigger: "blur" },
          { min: 6, max: 20, message: "长度在 6 到 20 个字符", trigger: "blur" },
          { pattern: /^[^<>"'|\\]+$/, message: "不能包含非法字符：< > \" ' \\\ |", trigger: "blur" }
        ],
        newPassword2: [
          { required: true, message: "确认密码不能为空", trigger: "blur" },
          { required: true, validator: equalToPassword, trigger: "blur" }
        ]
      },
      flag: true,
      userinfo: {}
    }
  },
  mounted() {
    this.getuser()
  },
  methods: {
    async handleDrop(e) {
      let files = e.target.files[0]
      let url = await uploadOssPut(files)
      saveUserInfo({ avatar: '/' + url.name }).then(res => {
        if (res.code == 1) {
          this.$modal.msgSuccess(`头像已修改`);
          this.getuser()
        }
      })
    },
    //修改头像
    setAvatar() {
      this.$refs.file.click()
    },
    chang() {
      this.flag = false
      this.$nextTick(() => {
        this.$refs.inputs.focus()
      })
    },
    //修改昵称
    confirm() {
      saveUserInfo({ nickname: this.userinfo.nickname }).then(res => {
        if (res.code == 1) {
          this.$modal.msgSuccess(`昵称已修改`);
          this.flag = true
          getUserInfo().then(res => {
            if (res.code == 1) {
              this.$store.commit('SetUserinfo', res.data)
            }
          })
        }
      })
    },
    getuser() {
      getUserInfo().then(res => {
        if (res.code == 1) {
          this.userinfo = Object.assign({}, res.data)
          this.$store.commit('SetUserinfo', res.data)
        }
      })
    },
    jcshouquan() {
      this.$confirm('确定要解除授权信息吗？', '提示', {
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        removeWxAuth().then(res => {
          this.getuser()
          this.$modal.msgSuccess(`授权信息已解除`);
        })
      }).catch(() => { });

    },
    open() {
      this.showPassword = true
    },
    submit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          changePassword(this.user).then(res => {
            if (res.code == 1) {
              this.$modal.msgSuccess(`密码已修改`);
              this.getuser()
            }
          })
        }
      });
    },
  },
}
</script>
<style lang='scss' scoped>
.page {
  padding: 39px 32px;
  box-sizing: border-box;
  background-color: #fff;
  min-height: 600px;
}

.toux {
  width: 100px;
  margin: 0 auto;
  text-align: center;

  img {
    width: 80px;
    height: 80px;
    border-radius: 40px;
  }

  .btn {
    width: 98px;
    height: 34px;
    background: #FFFFFF;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #DEDEDE;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #D9D9D9;
    line-height: 34px;
    cursor: pointer;
    margin-top: 6px;
  }
}

.infoBlock {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #000000;

  .ite {
    display: flex;
    align-items: center;
    margin-top: 50px;

    .text_l {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #ADAAAA;
    }

    .text_r_flex {
      display: flex;
      align-items: center;

      img {
        width: 30px;
        height: 30px;
        margin-right: 12px;
      }

      .btn {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #FF9500;
        margin-left: 30px;
        cursor: pointer;
      }
    }
  }
}

.zfpop {
  .dimg {
    width: 290px;
    height: 290px;
    border-radius: 10px 10px 10px 10px;
    border: 1px solid #DEDEDE;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px auto;

    img {
      width: 270px;
      height: 270px;
    }
  }

}


.inputflex {
  font-size: 16px;
  display: flex;
  align-items: center;
  height: 24px;

  input {
    max-width: 100px;
    border: none;
    outline: none;
    font-size: 16px;
  }

  .btn {
    margin-left: 30px;
    flex: 1;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #FF9500;
    cursor: pointer;
  }
}
</style>